import type { AgreementDocument } from 'api/agreement/types';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Typography,
  styled,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SanitizeHtml from 'components/SanitizeHtml';

interface AgreementAccordionProps {
  agreement: AgreementDocument;
}

const Title = styled(Typography)`
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.28;
  letter-spacing: 0.5px;
`;

export const AgreementAccordion = ({ agreement }: AgreementAccordionProps) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Title variant='h3' component='span'>
          {agreement.description}
        </Title>
      </AccordionSummary>
      <AccordionDetails>
        <Divider />
        <SanitizeHtml html={agreement.content} />
      </AccordionDetails>
    </Accordion>
  );
};
